import { axiosInstance } from '.'
import { GetNewsletterGroupsSearchParams, GetNewsletterSubscribersSearchParams } from '../lib/types'
import { removeEmptyValueFromObject } from '../lib/utils/helpers'
import { AttachmentFile } from '../pages/newsletter-form/newsletter-send-form-container'
import {
  FooterTemplateValue,
  HeaderTemplateValue,
} from '../pages/newsletter-form/newsletter-send-form-presenter'
import {
  GET_NEWSLETTER_GROUPS,
  GET_NEWSLETTER_SUBSCRIBERS,
  CREATE_NEWSLETTER_GROUP,
  GET_NEWSLETTER_GROUP_BY_ID,
  UPDATE_NEWSLETTER_GROUP_BY_ID,
  SEND_NEWSLETTER,
  UPLOAD_FILE,
} from './endpoints'

export type NewsletterGroupFormData = {
  name: string
  description: string
  emails: string[]
}

export type NewsletterSendFormData = {
  includeSubscribers: boolean
  groupIds: string[]
  subject: string
  body: string
  replyTo: string
  fromEmail: string
  cc: string[]
  bcc: string[]
  headerTemplate: HeaderTemplateValue
  footerTemplate: FooterTemplateValue
  attachments: AttachmentFile[]
}

export const newsletterServices = {
  getSubscribers: async (params: GetNewsletterSubscribersSearchParams) => {
    try {
      const response = await axiosInstance.get(GET_NEWSLETTER_SUBSCRIBERS, {
        params: removeEmptyValueFromObject(params),
      })
      return response
    } catch (error: any) {
      return error.response
    }
  },

  getGroups: async (params: GetNewsletterGroupsSearchParams) => {
    try {
      const response = await axiosInstance.get(GET_NEWSLETTER_GROUPS, {
        params: removeEmptyValueFromObject(params),
      })
      return response
    } catch (error: any) {
      return error.response
    }
  },

  createGroup: async (data: NewsletterGroupFormData) => {
    try {
      const response = await axiosInstance.post(CREATE_NEWSLETTER_GROUP, data)
      return response
    } catch (error: any) {
      return error.response
    }
  },

  getGroupById: async (groupId: string) => {
    try {
      const response = await axiosInstance.get(GET_NEWSLETTER_GROUP_BY_ID(groupId))
      return response
    } catch (error: any) {
      return error.response
    }
  },

  updateGroupById: async (groupId: string, data: NewsletterGroupFormData) => {
    try {
      const response = await axiosInstance.patch(UPDATE_NEWSLETTER_GROUP_BY_ID(groupId), data)
      return response
    } catch (error: any) {
      return error.response
    }
  },

  sendNewsletter: async (data: NewsletterSendFormData) => {
    try {
      const response = await axiosInstance.post(SEND_NEWSLETTER, data)
      return response
    } catch (error: any) {
      return error.response
    }
  },

  uploadFile: async (file: File) => {
    try {
      const formData = new FormData()
      formData.append('file', file)
      return await axiosInstance.post(UPLOAD_FILE, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
    } catch (error: any) {
      return error.response
    }
  },
}
